import { BeatLoader, ClipLoader } from 'react-spinners';

export const GLOBAL_ROUTER_PROGRESS_BAR_COLOR = '#873ba3';
export const LOADER_COLOR = '#2a471f';

enum LoaderVariant {
  BeatLoader = 'BeatLoader',
  Default = 'MoonLoader',
}

type LoaderProps = {
  variant?: LoaderVariant;
  size?: number;
};

export function Loader({ variant = LoaderVariant.Default, size = 30 }: LoaderProps) {
  switch (variant) {
    case LoaderVariant.BeatLoader:
      return (
        <BeatLoader color={LOADER_COLOR} loading={true} size={size} aria-label="Loading Spinner" data-testid="loader" />
      );
    default:
      return (
        <ClipLoader color={LOADER_COLOR} loading={true} size={size} aria-label="Loading Spinner" data-testid="loader" />
      );
  }
}
